import { PersistentUserReactionState } from './PersistentData';

export function addReaction(history: PersistentUserReactionState['history'], label: string) {
  const historyList = [...history];
  const sameItemIndex = historyList.findIndex(element => element.label === label);
  const additionalItem = { label };

  // 追加予定のリアクションが履歴に存在する場合は取り除く
  if (sameItemIndex !== -1) {
    historyList.splice(sameItemIndex, 1);
  }
  return [additionalItem, ...historyList];
}
